import { GcsImage } from "@zickko/shared";
import { clientConfig } from "../config/clientConfig";

export const getImageUrl = (image: GcsImage) => {
  const suffix = `${image.path}`;
  return `${clientConfig.imageServer}/${suffix}`;
};
